module.exports = __webpack_public_path__ + "static/img/zngk_p4.a8cfd60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/zngk_p4.png
// module id = ZcIL
// module chunks = 19